import React from 'react';
import {
	Box,
	Card,
	CardActions,
	CardContent,
	CardHeader,
	Divider,
	makeStyles,
	Typography,
} from '@material-ui/core';
import InvoiceItem from '../components/invoiceItem';
import { ArrowForwardIos as ArrowForwardIosIcon } from '@material-ui/icons';
import { useHistory, useParams } from 'react-router';
import clsx from 'clsx';
import layoutService from 'src/services/layoutService';
import { appMobileService } from 'src/services';

const useStyle = makeStyles(theme => ({
	root: {},
	header: {
		paddingBottom: 0
	},
	container: {
		paddingBottom: `${theme.spacing(2)}px !important`
	}
}));

function InvoicesSection({ entity, className }) {
	const classes = useStyle();
	const history = useHistory()
	const { contractLineId } = useParams();

	function handleClick() {
		if(appMobileService.isMobile() || layoutService.isMobile())
			history.push('/mobile/supply/invoices', { entity });
		else 
			history.push(`/app/supply/${contractLineId}/invoices`, { entity });
	}

	return (
		<Card className={clsx(classes.root, className)}>
			<CardHeader title="Fatture" className={classes.header} />
			{entity?.lastInvoice?.id ? (
				<>
					<CardContent className={classes.container}>
						<InvoiceItem
							entity={entity?.lastInvoice}
							disabled
							className={classes.invoice}
						/>
					</CardContent>
						
					<Divider />
						
					<CardActions>
						<Box
							my={2}
							mx={1}
							display="flex"
							alignItems="center"
							justifyContent="space-between"
							width="100%"
							onClick={handleClick}
							>
							<Typography variant="body1">Tutte le fatture</Typography>

							<ArrowForwardIosIcon fontSize="small" color="disabled" />
						</Box>
					</CardActions>
				</>
			) : ( 
				<CardContent className={classes.container}>
					<Typography variant="subtitle2" color="textSecondary">
						Nessuna fattura disponibile
					</Typography>
				</CardContent>
			)}
		</Card>
	);
}

export default InvoicesSection;
